import React, { useState } from "react";
export default function MessageInput(props) {
  const [message, setMessage] = useState("");
  const disabled = props.disabled || false;

  const onSend = () => {
    if (!message.trim()) return;
    if (disabled) return;
    if (props.onSend) {
      props.onSend(message);
    }
    setMessage("");
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      onSend();
    }
  };

  return (
    <>
      <div className="border-top pt-4">
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          onKeyPress={(e) => handleKeyPress(e)}
          className="form-control border-0 w-100"
          placeholder={disabled ? "Ожидайте ответа..." : "Задайте вопрос ассистенту"}
          disabled={disabled}
          rows={3}
        />
        <div className="d-flex justify-content-between mt-5">
          <div className="text-muted font-size-sm align-self-center">
            Enter — отправить, Shift+Enter — новая строка
          </div>
          <div>
            <button
              onClick={onSend}
              className="btn btn-light-primary"
              disabled={disabled || !message.trim()}
            >
              Отправить
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
